import { trackEvent, axiosInstance } from "@hopper-b2b/api";
import { type IApiConfig, NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { notifySuccessfulAuthPath } from "./paths";

// Timeout for the notify successful auth API call (30 seconds)
const NOTIFY_AUTH_TIMEOUT_MS = 30000;

interface NotifySuccessfulAuthOptions {
  apiConfig?: IApiConfig;
  authorizationCode?: string;
  /** Raw OAuth state string from NuPay callback (base64-encoded) */
  nupayOAuthState?: string;
}

export const notifySuccessfulAuth = (
  options?: NotifySuccessfulAuthOptions
): Promise<null> =>
  new Promise((resolve, reject) => {
    const body =
      options?.authorizationCode || options?.nupayOAuthState
        ? {
            ...(options?.authorizationCode && {
              authorizationCode: options.authorizationCode,
            }),
            ...(options?.nupayOAuthState && { state: options.nupayOAuthState }),
          }
        : undefined;

    axiosInstance
      .post(notifySuccessfulAuthPath, body, {
        timeout: NOTIFY_AUTH_TIMEOUT_MS,
      })
      .then((res) => {
        const responseBody = res.data;
        resolve(responseBody);
      })
      .catch((e) => {
        const isTimeout =
          e?.code === "ECONNABORTED" || e?.message?.includes("timeout");
        trackEvent(
          {
            eventName: NETWORK_CALL_FAILED,
            properties: {
              url: window.location.pathname,
              error_type: isTimeout ? "timeout" : "network_error",
              error_message: e?.message,
            },
          },
          options?.apiConfig
        );
        reject(e);
      });
  });
